import React from 'react';
import ContentLoader from 'react-content-loader';
import { Col } from 'reactstrap';
import './Calendar.scss';

const CalendarLoader = () => {
  return (
    <Col className="calendar-loader" xs="12" sm="12" md="12">
      <ContentLoader height={190} speed={2}>
        <div className={'d-none'} id={'tooltipLeft'} />
        <rect className="placeholder-rect-1" />
        <rect className="placeholder-rect-2" />
        <div className={'d-none'} id={'tooltipRight'} />
      </ContentLoader>
    </Col>
  );
};

export default CalendarLoader;



// WEBPACK FOOTER //
// ./src/components/organisms/Calendar/CalendarLoader.js